import { assetUrl } from "~/utils/assetUrl"
import { archetypeImageUrl } from "~/utils/archetypeImageUrl"
import type { DogPortraitInfo } from "~/api/auth"

export function heroPortraitUrl(
  archetypeIcon: string | null | undefined,
  portrait?: DogPortraitInfo | null,
): string | null {
  if (portrait?.status === "ready" && portrait.url) {
    if (portrait.url.startsWith("http")) return portrait.url
    if (portrait.url.startsWith("/share-assets/")) return portrait.url
    // Active Storage blobs are served by the app, not from the static asset CDN.
    if (portrait.url.includes("/rails/active_storage/")) return portrait.url
    return assetUrl(portrait.url)
  }
  if (!archetypeIcon) return null
  return archetypeImageUrl(archetypeIcon, "portraits")
}

export function heroPortraitShareUrl(
  archetypeIcon: string | null | undefined,
  portrait?: DogPortraitInfo | null,
): string | null {
  const url = heroPortraitUrl(archetypeIcon, portrait)
  if (!url) return null
  if (url.startsWith("/share-assets/")) return url
  if (url.includes("/rails/active_storage/")) {
    const path = url.startsWith("http") ? new URL(url).pathname : url
    return `/share-assets${path}`
  }
  return url
}
